import {
  Button,
  Dialog,
  DialogContent,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { APP_ICONS } from "../../assets";
import TextInput from "../textInput/index";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },
  "& .MuiPaper-root": {
    width: "550px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

let paramsData = {};

const EditVendorDialog = forwardRef(
  ({ handleUpdate, handleInputChange, formData, setFormData }, ref) => {
    const [open, setOpen] = useState(false);
    useImperativeHandle(ref, () => ({
      openDialog(params) {
        paramsData = params;
        setFormData({
          name: params?.name || "",
          email: params?.email || "",
          phoneNumber: params?.phoneNumber || "",
          bbShare: params?.bbShare || 0,
          vendorShare: params?.vendorShare || 0,
          customerShare: params?.customerShare || 0,
          vendorReferedShare: params?.vendorReferedShare || 0,
        });
        setOpen(true);
      },
      closeDialog() {
        setOpen(false);
      },
    }));

    const handleClose = () => {
      setOpen(false);
    };
    return (
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogContent>
          <Typography
            fontSize={"1.375rem"}
            fontWeight={600}
            textAlign={"center"}
            color={"primary.light"}
          >
            {/* Edit Personal Details */}
          </Typography>

          <Grid container rowSpacing={2} mt={3}>
            <Grid size={12}>
              <InputLabel>Name</InputLabel>
              <TextInput
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid size={12}>
              <InputLabel>Email</InputLabel>
              <TextInput
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid size={12}>
              <InputLabel>Phone</InputLabel>
              <TextInput
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
              />
            </Grid>
            {paramsData?.role == "vendor" && (
              <>
                <Grid size={12}>
                  <InputLabel>BB Share</InputLabel>
                  <TextInput
                    name="bbShare"
                    value={formData.bbShare}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid size={12}>
                  <InputLabel>Vendor Share</InputLabel>
                  <TextInput
                    name="vendorShare"
                    value={formData.vendorShare}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid size={12}>
                  <InputLabel>Customer Share</InputLabel>
                  <TextInput
                    name="customerShare"
                    value={formData.customerShare}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid size={12}>
                  <InputLabel>Refered Vendor Share</InputLabel>
                  <TextInput
                    name="vendorReferedShare"
                    value={formData.vendorReferedShare}
                    onChange={handleInputChange}
                  />
                </Grid>
              </>
            )}
          </Grid>

          <Stack direction={"row"} alignItems={"center"} gap={1} mt={4}>
            <Button
              variant="custom_outlined"
              onClick={handleUpdate}
              endIcon={<img src={APP_ICONS.fileSaveIconBlue} width={22} />}
            >
              Update & Save
            </Button>
            <Button variant="suspend_button" onClick={handleClose}>
              Discard
            </Button>
          </Stack>
        </DialogContent>
      </BootstrapDialog>
    );
  }
);

export default EditVendorDialog;
